import angular from 'angular'

import './webregister'

import { SelectRegisterController } from './register/select-register'

angular
  .module('webregister.controllers')
  .controller('SelectRegisterController', SelectRegisterController)
